(() => {
  const cards = [...document.querySelectorAll('.review-card')];
  const dots = [...document.querySelectorAll('.review-dot')];
  const track = document.querySelector('.review-grid');
  const previous = document.querySelector('.review-button--prev');
  const next = document.querySelector('.review-button--next');
  if (!cards.length || !track || !previous || !next) return;
  let active = 0;
  let cloneCount = 0;
  let physicalIndex = 0;
  let suppressScroll = false;
  let dragging = false;
  let moved = false;
  let startX = 0;
  let startScroll = 0;
  let scrollFrame;
  let scrollTimer;
  let resizeTimer;

  const modulo = (value, length) => ((value % length) + length) % length;
  const wantedCloneCount = () => window.innerWidth <= 767 ? 1 : window.innerWidth <= 1190 ? 2 : 3;

  const step = () => {
    const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
    return cards[0].getBoundingClientRect().width + gap;
  };

  const updateDots = () => {
    cards.forEach((card, index) => card.classList.toggle('is-mobile-active', index === active));
    dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === active)));
  };

  const jump = (nextPhysicalIndex) => {
    physicalIndex = nextPhysicalIndex;
    suppressScroll = true;
    track.classList.add('is-jumping');
    track.scrollLeft = physicalIndex * step();
    requestAnimationFrame(() => requestAnimationFrame(() => {
      track.classList.remove('is-jumping');
      suppressScroll = false;
    }));
  };

  const show = (nextPhysicalIndex, behavior = 'smooth') => {
    physicalIndex = nextPhysicalIndex;
    active = modulo(physicalIndex - cloneCount, cards.length);
    updateDots();
    track.scrollTo({ left: physicalIndex * step(), behavior });
  };

  const settle = () => {
    physicalIndex = Math.round(track.scrollLeft / step());
    active = modulo(physicalIndex - cloneCount, cards.length);
    updateDots();
    if (physicalIndex < cloneCount) {
      jump(physicalIndex + cards.length);
    } else if (physicalIndex >= cloneCount + cards.length) {
      jump(physicalIndex - cards.length);
    }
  };

  const syncDotsFromScroll = () => {
    scrollFrame = undefined;
    if (suppressScroll) return;
    const nextActive = modulo(Math.round(track.scrollLeft / step()) - cloneCount, cards.length);
    if (nextActive === active) return;
    active = nextActive;
    updateDots();
  };

  const makeClone = (card) => {
    const clone = card.cloneNode(true);
    clone.classList.add('is-clone');
    clone.classList.remove('is-mobile-active');
    clone.setAttribute('aria-hidden', 'true');
    clone.querySelectorAll('img').forEach((image) => image.setAttribute('draggable', 'false'));
    return clone;
  };

  const rebuild = () => {
    track.querySelectorAll('.review-card.is-clone').forEach((card) => card.remove());
    cloneCount = Math.min(wantedCloneCount(), cards.length);
    const leadingClones = cards.slice(-cloneCount).map(makeClone);
    const trailingClones = cards.slice(0, cloneCount).map(makeClone);
    track.prepend(...leadingClones);
    track.append(...trailingClones);
    updateDots();
    requestAnimationFrame(() => jump(cloneCount + active));
  };

  previous.addEventListener('click', () => show(physicalIndex - 1));
  next.addEventListener('click', () => show(physicalIndex + 1));
  dots.forEach((dot, index) => dot.addEventListener('click', () => show(cloneCount + index)));

  track.addEventListener('scroll', () => {
    if (suppressScroll) return;
    if (!scrollFrame) scrollFrame = requestAnimationFrame(syncDotsFromScroll);
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(settle, 90);
  }, { passive: true });

  track.addEventListener('pointerdown', (event) => {
    if (event.pointerType === 'touch' || event.button !== 0) return;
    dragging = true;
    moved = false;
    startX = event.clientX;
    startScroll = track.scrollLeft;
    track.classList.add('is-dragging');
    track.setPointerCapture(event.pointerId);
    event.preventDefault();
  });

  track.addEventListener('pointermove', (event) => {
    if (!dragging) return;
    const distance = event.clientX - startX;
    moved = moved || Math.abs(distance) > 4;
    track.scrollLeft = startScroll - distance;
    event.preventDefault();
  });

  const finishDrag = (event) => {
    if (!dragging) return;
    dragging = false;
    track.classList.remove('is-dragging');
    if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
    show(Math.round(track.scrollLeft / step()));
  };

  track.addEventListener('pointerup', finishDrag);
  track.addEventListener('pointercancel', finishDrag);
  track.addEventListener('dragstart', (event) => event.preventDefault());
  track.addEventListener('click', (event) => {
    if (!moved) return;
    event.preventDefault();
    event.stopPropagation();
    moved = false;
  }, true);

  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(rebuild, 120);
  });
  rebuild();
})();
